<template>
    <div>
        <ProjectServicesTop />
        <div class="aftermarketDivision">
            <div class="titleStyle">
                <div class="titleFont">后市场服务</div>
                <div class="conentFont">
                    <div class="divide"></div>
                    <span class="enFont">AFTERMARKET DIVISION</span>
                    <div class="divide"></div>
                </div>
            </div>
            <div class="describeFont">
                {{ aftermarketDivisionList.description }}
            </div>
        </div>

        <div class="titleStyle">
            <div class="titleFont">主营业务</div>
            <div class="conentFont">
                <div class="divide"></div>
                <span class="enFont">MAIN BUSINESS</span>
                <div class="divide"></div>
            </div>
        </div>
        <div class="mainBusiness">
            <div class="mainBusinessList">
                <div
                    class="mainBusinessItem"
                    v-for="(item, idx) in mainBusinessList"
                    :key="idx"
                    v-show="idx < 4"
                >
                    <div
                        :class="[
                            'mainBusinessItemConent' + idx,
                            'mainBusinessItemConent',
                            idx < 3 ? 'mainBusinessItemRightBorder' : '',
                        ]"
                    >
                        <div class="mainBusinessItemImg">
                            <img :src="item.image" />
                        </div>
                        <div class="mainBusinessItemTitle">
                            {{ item.title }}
                        </div>
                        <div class="mainBusinessItemDescription">
                            {{ item.description }}
                        </div>
                        <!-- <div class="mainBusinessItemHover">
                            <img
                                src="../../assets/projectServices/noHover.png"
                                class="itemNoHover"
                            />
                            <img
                                src="../../assets/projectServices/hover.png"
                                class="itemHover"
                            />
                        </div> -->
                    </div>
                </div>
            </div>
        </div>
        <div class="majorStrategicCooperativeBrands">
            <div class="titleStyle">
                <div class="titleFont">主要产品与服务</div>
                <div class="conentFont">
                    <div class="divide"></div>
                    <span class="enFont">Main products and services</span>
                    <div class="divide"></div>
                </div>
            </div>
            <div class="majorStrategicCooperativeBrandsList">
                <div
                    class="listItem"
                    v-for="(item, idx) in majorStrategicCooperativeBrandsList"
                    :key="idx"
                    v-show="idx < 5"
                    :style="{
                        backgroundImage: 'url(' + item.image + ')',
                    }"
                >
                    <div class="itemTitle">{{ item.title }}</div>
                    <div class="itemContent">
                        <div
                            class="itemContentItem"
                            v-for="(iitem, i) in item.newDescription"
                            :key="i"
                            v-show="i < 3"
                        >
                            {{ iitem }}
                        </div>
                    </div>
                    <div class="itemLine"></div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import $ from "jquery";
import ProjectServicesTop from "@/components/ProjectServicesTop.vue";
import { getAction } from "@/api/services";
export default {
    name: "AftermarketService",
    components: {
        ProjectServicesTop,
    },
    data() {
        return {
            url: "/jhwlweb/gwweb/cmsArticleCategory/queryServiceList",
            aftermarketDivisionList: {},
            mainBusinessList: {},
            majorStrategicCooperativeBrandsList: [],
            canShow: true,
        };
    },
    created() {
        this.getInfo();
    },
    mounted() {
        $(window).on("scroll", this.handScroll);
    },
    destroyed() {
        $(window).off("scroll");
    },
    methods: {
        handScroll() {
            // 智慧物流
            let wisdomLogisticsTop =
                $(".mainBusiness").offset().top -
                $(".mainBusiness").height() -
                130;
            let boxTop =
                document.documentElement.scrollTop || document.body.scrollTop;
            if (boxTop > wisdomLogisticsTop && this.canShow) {
                $(".mainBusinessItemConent").animate(
                    { "margin-top": "0" },
                    700
                );
                $(".mainBusinessItemConent").css("opacity", 1);
                this.canShow = false;
            }
        },
        getInfo() {
            let that = this;
            let parmas = {
                menuCategory: 60,
            };
            getAction(that.url, parmas).then((res) => {
                if (res.code == 200 && res.success) {
                    res.result.records.forEach((item, idx) => {
                        if (idx == 0) {
                            that.aftermarketDivisionList = item;
                        } else if (idx == 1) {
                            that.mainBusinessList = item.cmsArticleList;
                        } else {
                            let newArr = item.cmsArticleList;
                            newArr.forEach((item) => {
                                item["newDescription"] =
                                    item.description.split("\n");
                            });
                            that.majorStrategicCooperativeBrandsList = newArr;
                        }
                    });
                }
            });
        },
    },
};
</script>
<style lang="less" scoped>
.beyondOne {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
}
.bgSet {
    background-position: center center;
    background-size: cover;
    background-repeat: no-repeat;
}
.typeArea {
    max-width: 1100px;
    margin: 0 auto;
}
.titleStyle {
    .typeArea();
    padding-bottom: 80px;
    padding-top: 90px;
    text-align: center;
    width: 100%;
    .titleFont {
        font-family: "阿里巴巴普惠体";
        font-size: 32px;
        line-height: 28px;
        letter-spacing: 2px;
        color: #333333;
    }
    .conentFont {
        margin-top: 8px;
        .divide {
            display: inline-block;
            vertical-align: super;
            width: 20px;
            height: 2px;
            background-color: #0052d9;
        }
        .enFont {
            margin: 0 10px;
            font-family: "微软雅黑";
            font-size: 16px;
            letter-spacing: 0px;
            color: #333333;
            opacity: 0.5;
        }
    }
}
.describeFont {
    .typeArea();
    padding: 0 50px;
    font-size: 18px;
    letter-spacing: 1.1px;
    line-height: 1.6em;
    color: #333333;
    margin-bottom: 100px;
}
.mainBusiness {
    .bgSet();
    background: url("../../assets/projectServices/mainBusiness.png");
    width: 100%;
    height: 430px;
    display: block;
    .mainBusinessList {
        .typeArea();
        display: flex;
        justify-content: space-around;
        .mainBusinessItem {
            cursor: pointer;
            width: 25%;
            height: 430px;
            .mainBusinessItemConent {
                margin-top: 300px;
                opacity: 0;
                padding: 0 20px;
                height: 380px;
                .mainBusinessItemImg {
                    margin-top: 30px;
                    width: 30px;
                    height: 30px;
                    img {
                        height: 100%;
                        width: 100%;
                    }
                }
                .mainBusinessItemTitle {
                    margin-top: 40px;
                    font-family: "优选标题黑";
                    font-size: 32px;
                    color: #ffffff;
                }
                .mainBusinessItemDescription {
                    .beyondOne();
                    margin-top: 20px;
                    width: 234px;
                    font-size: 16px;
                    height: 72px;
                    text-align: justify;
                    color: #ffffff;
                }
                .mainBusinessItemHover {
                    margin-top: 66px;
                    padding-bottom: 90px;
                    .itemNoHover {
                        display: block;
                    }
                    .itemHover {
                        display: none;
                    }
                }
            }
            .mainBusinessItemRightBorder {
                border-right: 1px solid rgba(255, 255, 255, 0.1);
            }
        }
        .mainBusinessItem:hover {
            background-color: rgba(0, 82, 217, 0.1);
            .mainBusinessItemConent {
                .mainBusinessItemHover {
                    .itemNoHover {
                        display: none;
                    }
                    .itemHover {
                        display: block;
                    }
                }
            }
        }
    }
}
.majorStrategicCooperativeBrands {
    .majorStrategicCooperativeBrandsList {
        .typeArea();
        margin-bottom: 50px;
        display: flex;
        .listItem {
            width: 100%;
            height: 300px;
            .bgSet();
            position: relative;
            .bgSet();
            .itemTitle {
                position: absolute;
                left: 0;
                width: 100%;
                height: 300px;
                text-align: center;
                font-family: "优设标题黑";
                font-size: 32px;
                line-height: 300px;
                letter-spacing: 1px;
                color: #ffffff;
            }
            .itemContent {
                opacity: 0;
                position: absolute;
                left: 0;
                bottom: 5px;
                width: 100%;
                height: 190px;
                background-color: rgba(0, 0, 0, 0.5);
                .itemContentItem {
                    margin-top: 20px;
                    font-size: 18px;
                    text-align: center;
                    color: #ffffff;
                }
            }
            .itemLine {
                position: absolute;
                left: 0;
                bottom: 0;
                width: 100%;
                height: 5px;
                background-color: #0052d9;
                opacity: 0;
            }
        }
        .listItem:hover {
            .itemTitle {
                transition: all 0.2s ease-in;
                line-height: 120px;
            }
            .itemContent {
                transition: all 0.2s ease-in;
                opacity: 1;
            }
            .itemLine {
                transition: all 0.2s ease-in;
                opacity: 1;
            }
        }
    }
}
</style>
